import { supabase } from "@/lib/data"
import { useTeamStore } from "@/lib/hooks/useTeam"

export async function deleteTeam(teamId: string): Promise<void> {
  const { data: collectionIds } = await supabase
    .from("collections")
    .select("id")
    .eq("team_id", teamId)
  const collectionIdList = (collectionIds || []).map((c) => c.id)

  const { data: sourceIds } = await supabase
    .from("sources")
    .select("id")
    .eq("team_id", teamId)
  const sourceIdList = (sourceIds || []).map((s) => s.id)

  if (collectionIdList.length > 0) {
    await supabase
      .from("collection_sources")
      .delete()
      .in("collection_id", collectionIdList)
  }

  if (sourceIdList.length > 0) {
    await supabase
      .from("collection_sources")
      .delete()
      .in("source_id", sourceIdList)
  }

  await supabase.from("user_teams").delete().eq("team_id", teamId)
  await supabase.from("chat_history").delete().eq("team_id", teamId)
  await supabase.from("vectors").delete().eq("team", teamId)
  await supabase.from("live_data_elements").delete().eq("team_id", teamId)
  await supabase.from("eval_results").delete().eq("team_id", teamId)
  await supabase.from("eval_configs").delete().eq("team_id", teamId)
  await supabase.from("source_configs").delete().eq("team_id", teamId)
  await supabase.from("collections").delete().eq("team_id", teamId)
  await supabase.from("sources").delete().eq("team_id", teamId)
  await supabase.from("bots").delete().eq("team_id", teamId)
  await supabase.from("agents").delete().eq("team_id", teamId)
  await supabase.from("api_keys").delete().eq("team_id", teamId)
  await supabase.from("system_prompts").delete().eq("team_id", teamId)
  await supabase.from("projects").delete().eq("team", teamId)
  await supabase.from("domains").delete().eq("team", teamId)
  await supabase.from("jobs").delete().eq("team", teamId)
  await supabase.from("kbsources").delete().eq("team", teamId)
  await supabase.from("history").delete().eq("team", teamId)
  await supabase.from("logs").delete().eq("team_id", teamId)

  await supabase.from("roles").delete().eq("team_id", teamId)

  const { data: rolesWithTeamInArray } = await supabase
    .from("roles")
    .select("id, teams_id")
    .not("teams_id", "is", null)

  if (rolesWithTeamInArray) {
    for (const role of rolesWithTeamInArray) {
      if (role.teams_id?.includes(teamId)) {
        const updatedTeamsId = role.teams_id.filter((t) => t !== teamId)
        await supabase
          .from("roles")
          .update({ teams_id: updatedTeamsId })
          .eq("id", role.id)
      }
    }
  }

  await supabase.from("users").update({ team: null }).eq("team", teamId)
  await supabase.from("teams").delete().eq("id", teamId)

  if (useTeamStore.getState().selectedTeam?.id === teamId) {
    useTeamStore.getState().setSelectedTeam(null)
  }
}

export async function deleteTeams(teamIds: string[]): Promise<void> {
  for (const teamId of teamIds) {
    await deleteTeam(teamId)
  }
}
